import React from 'react'
import { useWorkListViewMnStore } from 'context/WorkListViewStore/Manager/WorkListViewStore.manager'
import { makeStyles } from '@material-ui/core'
import OneCInfo from 'components/Desktop/WorkListView/OneCInfo'
import ContractInfo from 'components/Desktop/WorkListView/ContractInfo'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    paddingLeft: 16,
    paddingRight: 16,
    width: '100%'
  }
}))
const PaymentsTab = () => {
  const classes = useStyles()
  const {
    workListViewStore: { contract, agreement }
  } = useWorkListViewMnStore()
  return (
    <div className={classes.root}>
      <OneCInfo listArr={contract?.request1cWorkLists || []} />
      <OneCInfo
        title={'Загрузка запроса на выдачу в 1С'}
        listArr={contract?.request1cSppIssues || []}
      />
      <ContractInfo sumDKP={0} paymentData={agreement?.payments} />
    </div>
  )
}

export default PaymentsTab
